import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import ReactEcharts from 'echarts-for-react';
import noPicture from './img/noPicture.png';
import defaultImg from './img/defaultImg.png';

/**
 * 等比计算宽高
 * @param imgWidth
 * @param imgHeight
 * @param containerWidth
 * @param containerHeight
 * @returns {{width: number, height: number}}
 */
const scalingImage = (imgWidth, imgHeight, containerWidth, containerHeight) =>{
    let containerRatio = containerWidth / containerHeight;
    let imgRatio = imgWidth / imgHeight;

    if (imgRatio > containerRatio) {
        imgWidth = containerWidth;
        imgHeight = containerWidth / imgRatio;
    } else if (imgRatio < containerRatio) {
        imgHeight = containerHeight;
        imgWidth = containerHeight * imgRatio;
    } else {
        imgWidth = containerWidth;
        imgHeight = containerHeight;
    }

    return { width: imgWidth, height: imgHeight };
};

export default class RelationshipMap  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            data:[],
            id:this.props.virtualFileId
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps)
        if(nextProps.virtualFileId!=this.state.id){
            this.state.id=nextProps.virtualFileId;
            this.setState({},()=>{
                this.getData()
            })
        }

    }
    componentWillMount() {
        console.log(this.props.id,'--------------')
    }
    componentDidMount() {

        this.getData()
    }

    render() {
        return(
            <div>
                <ReactEcharts style={{height:400}}
                    option={this.getOptions()}
                    className={'react_for_echarts'}
                />
            </div>

        )
    }
    getOptions(){
        this.getNodeData();
        let imgMaxWidth = 50;
        let imgMaxHeight = 50;

        return  {
            tooltip: {
                backgroundColor: 'rgba(50,50,50,0.9)',
                formatter: function (param) {
                    let name = param.data.nameStr;
                    return name;
                },
                show:true,
                position: function (pos, params, dom, rect, size) {
                    // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
                    dom.style.maxWidth = "150px";
                    dom.style.height = "auto";
                    dom.style.whiteSpace="break-spaces";
                    dom.style.left="0"
                },
            },
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
                {
                    type: 'graph',
                    layout: 'force',
                    force: {
                        repulsion: 1000,
                        edgeLength: [150, 100]
                    },
                    symbolSize: (a, node)=>{
                        let res = scalingImage(node.data.width, node.data.height, imgMaxWidth, imgMaxHeight);
                        return [res.width, res.height];
                    },
                    draggable: false,
                    label: {
                        normal: {
                            overflow:"break",
                            show: true,
                            textStyle: {
                               color:'rgba(0, 0, 0, 0.85)'
                            },
                            position: 'bottom',
                            formatter: function (param) {
                                let name = param.data.nameStr;
                                if (name && name.indexOf('|') > -1) {
                                    name = name.split('|')[0]
                                }
                                if (name &&name.length > 20) {
                                    name = name.substring(0, 20) + "...";
                                    name = name.substring(0,10) + "\n" + name.substr(10,20);
                                }
                                return name;
                            }
                        }
                    },
                    width: '90%',
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    edgeLabel: {
                        normal: {
                            show: true,
                            formatter: function (param) {
                                return param.data.category;
                            }
                        }
                    },

                    data: this.state.dataArray,
                    itemStyle:{
                        borderWidth:10,
                        borderColor: "rgba(197, 171, 171, 0.45)",
                        borderCap:"square"
                    },
                    links: this.state.linkArray,
                    lineStyle: {
                        opacity: 0.9,
                        width: 1,
                    }
                }
            ]
        };
    }


    //组装link
    linkNodeData(item){
       let links  =[];
        links.push({
            source: item.relationship.start + '',
            target: item.relationship.end + '',
            entity: item,
            category: item.relationship.type,
            lineStyle: {
                normal: { curveness:0 }
            },
            value:item.relationship.type,
            label:{

            }
        });
        return links;
    }
    //组装数据 dataArray 将返回的start数据 以及end 数据去重组装成一个数组
    getNodeData() {
        let dataArray = [];
        let linkArray = [];
        let res = this.state.data;
        if(!res.length){
            dataArray.push({
                nameStr:'本资源',
                name:'0',
                symbol: "image://"+defaultImg,
        });
        }
        let uuidTempArray = [];
        res&&res.length&&res.forEach((item,index)=>{
            let nodeData ={};
            nodeData.link = this.linkNodeData(item);
            linkArray = linkArray.concat(nodeData.link);
            if(uuidTempArray.indexOf(item.end.id + '') < 0){
                nodeData ={
                    data: {
                        entity: item,
                        nameStr:item.end.property.name,
                        width:item.end.width,
                        height:item.end.height,
                        name: item.end.id + '',
                        symbol:item.end.property.icon?"image://"+item.end.property.icon:"image://"+noPicture,
                    },
                };
                uuidTempArray.push(item.end.id + '');
                dataArray.push(nodeData.data);
            }
            if(uuidTempArray.indexOf(item.start.id + '') < 0){
                nodeData ={
                    data: {
                        entity: item,
                        nameStr:item.start.property.name,
                        name: item.start.id + '',
                        width:item.start.width,
                        height:item.start.height,
                        symbol:item.start.property.icon?"image://"+item.start.property.icon:"image://"+noPicture,
                    },
                };
                uuidTempArray.push(item.start.id + '');
                dataArray.push(nodeData.data);
            }
        });
        this.state.dataArray=dataArray;
        this.state.linkArray=linkArray
    }
   //获取数据
    getData(){
        console.log(this.props.virtualFileId,'this.props.virtualFileId')
        this.request({
            url: '/cm-sites-storage-management/relation/queryAllRelation',
            method: 'post',
            body: {
                label:this.props.story?"Story": "VirtualFile",
                property: {
                    id:this.state.id
                }
            },
            contentType: "json",
            callBack: async (data) => {
                window.loading.show(true);
                let dataSource=[];
                if (data) {
                    dataSource = data
                }
                for(let i = 0 ; dataSource && i < dataSource.length ; i++){
                    let item = dataSource[i];
                    if(item.start && item.start.property && item.start.property.icon){
                        let src = item.start.property.icon;
                        await this.loadIconWidthAndHeight(src).then(({width, height})=>{
                            item.start.width = width;
                            item.start.height = height;
                        });
                    }
                    if(item.end && item.end.property && item.end.property.icon){
                        let src = item.end.property.icon;
                        await this.loadIconWidthAndHeight(src).then(({width, height})=>{
                            item.end.width = width;
                            item.end.height = height;
                        });
                    }
                }

                window.loading.hide();
                this.setState({data:dataSource},()=>{})
            }
        });
    }

    loadIconWidthAndHeight = async (url)=>{
        return new Promise((resolve) => {
            let img = document.createElement("img");
            img.src = url;
            img.onload = () => {
                // 为什么要写 onload  是因为要等他加载完之后才能获取到图片宽高
                let obj = {width:img.naturalWidth,height: img.naturalHeight};
                resolve(obj);
            };
        });
    }
}
